import { render, staticRenderFns } from "./ExtraServiceTypeSelect.vue?vue&type=template&id=240bfbfe&scoped=true"
import script from "./ExtraServiceTypeSelect.vue?vue&type=script&lang=ts"
export * from "./ExtraServiceTypeSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240bfbfe",
  null
  
)

export default component.exports